import _ from 'lodash';
import store from '../utils/store';
import { getShopId } from './firebase'

import {
  API_CREATE_PROMOTION,
  SUITABLE_TECHS,
  BUSINESS_TYPE_CODE,
  API_SYNCHRONIZE_MENU,
  API_UPDATE_PROMO,
  ZELTY
} from '../constants';
import {
  updateExpiredPromotion, updateSupportConfiguration,
  updateDeliveryServicePrice, deleteShopDeliveryUserServicePrice,
  updateShopMethodType,
  updateShopOpenCitiesCityName, updateShopDeliveryZoneName,
  deleteShopDeliveryZone, updateShopSubLocalitiesAndDistricts,
  updateShopSpecialHour, updateShopInformation, deleteShopSpecialHour,
  updateDeliveryServiceFee, updateConfigurationMethodType, deleteConfigurationUserServicePrice,
  updateDriversPaymentValues
} from './backend';
import { sendPostRequest, sendPutRequest } from '../utils/apiService'
import { checkAccess, getUserPermissions } from '../utils/admins';
import { updateOrderTypes } from '../utils/shopUtils';
import { hasExternalIntegration } from 'src/utils/externalIntegration';
import { getAllShopsPromotions } from 'src/pages/PromoCodes/PromoCodes.services';

export { getShopId } from './firebase' // just an alias

export const updateCollection = async (driverId, espece, cb, ticket_resto) => {
  try {
    const paymentValues = {
      cash: parseFloat(espece),
      cb: parseFloat(cb),
      ticket_resto: parseFloat(ticket_resto),
    }
    await updateDriversPaymentValues(driverId, paymentValues)

  } catch (err) {
    console.error(err); // Gérer les erreurs de manière appropriée
    throw err
  }
};

export const addPromo = async (promotion) => {
  const { shops = {} } = store.getState().firebaseRealTime;
  const { isGeneralData } = promotion
  const hasAccess = checkAccess('features', 'globalCodePromo')

  if (hasAccess && isGeneralData && shops) {
    for (const key of _.keys(shops)) {
      sendPostRequest(
        API_CREATE_PROMOTION,
        { shopId: key, promotion },
        {}
      );
    }
  } else {
    await sendPostRequest(
      API_CREATE_PROMOTION,
      { shopId: getShopId(), promotion },
      {}
    );
  }
};

export const removePromo = async (key, activation, promotions) => {
  const { shops = {} } = store.getState().firebaseRealTime;
  const { isGeneralData } = promotions[key];

  if (checkAccess('features', 'modifyGlobalPromo') && isGeneralData) {
    if (shops) {
      for (const shopId in shops) {
        await updateExpiredPromotion(shopId, key, !activation)
      }
    }
  } else {
    await updateExpiredPromotion(getShopId(), key, !activation)
  }
}
export const updatePromo = async (promotion) => {
  const { shops = {} } = store.getState().firebaseRealTime;
  const { companyId, shopId } = store.getState().user;
  const { isGeneralData, promoCode } = promotion
  const hasAccess = checkAccess('features', 'globalCodePromo')

  if (hasAccess && isGeneralData && shops) {
    const allPromotions = getAllShopsPromotions(shops)
    for (const key of _.keys(shops)) {
      if (hasExternalIntegration(key) !== ZELTY) {
        if ((allPromotions[promoCode]?.shopIds ?? []).includes(key)) {
          sendPutRequest(
            API_UPDATE_PROMO(companyId, key, promoCode),
            promotion,
            {}
          );
        } else {
          sendPostRequest(
            API_CREATE_PROMOTION,
            { shopId: key, promotion },
            {}
          )
        }
      }

    }
  } else {
    await sendPutRequest(
      API_UPDATE_PROMO(companyId, shopId, promoCode),
      promotion,
      {}
    );
  }
};

export const updateSupportConfigForShop = async configurations => {
  const { support, charges, cancelFee } = configurations
  await updateSupportConfiguration(charges, support, cancelFee);
}


export const updateDeliveryFee = async (data, isClient, shopIdIfNotAllShops) => {
  if (shopIdIfNotAllShops) {
    await updateDeliveryServicePrice(isClient, data)
  } else {
    await updateDeliveryServiceFee(isClient, data)
  }
}

export const deleteUserServicePrice = async shopIdIfNotAllShops => {
  if (shopIdIfNotAllShops) {
    await deleteShopDeliveryUserServicePrice()
  } else {
    await deleteConfigurationUserServicePrice()
  }
}

export const updateMethodTypeConfig = async configurations => {
  const {
    paymentTypes,
    orderTypes,
    orderTypesRef,
    paymentTypesRef,
    checkedDeliveryTypes,
    generalOrderTypes
  } = configurations;
  const { isAllShops, shopId, nbShops } = store.getState().user;
  const { isAdminOfThisShop } = await getUserPermissions(shopId);
  const type = orderTypes || paymentTypes;
  const methodType = orderTypes ? 'orderTypes' : 'paymentTypes';
  const typeRef = orderTypesRef || paymentTypesRef
  const newConfig = { terminal: {}, qrcode: {}, delivery: {} }

  if (isAllShops) {
    newConfig[methodType] = type['Commande à distance'];
    if (paymentTypes) {
      newConfig.terminal.paymentTypes = paymentTypes.Borne || null
      newConfig.qrcode.paymentTypes = paymentTypes[SUITABLE_TECHS.qrcode] || null
      newConfig.delivery.paymentTypes = checkedDeliveryTypes['Commande à distance'];
    }
  }
  else {
    const shopUpdates = { [methodType]: type['Commande à distance'] }
    if (orderTypes) {
      const newType = _.cloneDeep(type)
      shopUpdates?.orderTypes?.forEach(orderType => {
        if (!generalOrderTypes.includes(orderType)) {
          generalOrderTypes.push(orderType)
        }
      });

      newType['Commande à distance'] = generalOrderTypes
      newConfig[methodType] = updateOrderTypes(getShopId(), newType)
      if (!isAdminOfThisShop && nbShops === 1) {
        newConfig.orderTypes = shopUpdates.orderTypes
      }
    }
    if (paymentTypes) {
      newConfig.terminal.paymentTypes = paymentTypes.Borne || null
      newConfig.qrcode.paymentTypes = paymentTypes[SUITABLE_TECHS.qrcode] || null
      if (!isAdminOfThisShop && nbShops === 1) {
        newConfig.delivery.paymentTypes = checkedDeliveryTypes['Commande à distance']
      }
      if (!isAdminOfThisShop && !isAllShops) {
        shopUpdates.delivery = { paymentTypes: checkedDeliveryTypes['Commande à distance'] }
      }
    }
    if (hasExternalIntegration()) {
      shopUpdates.refs = { [methodType]: typeRef }
    }
    await updateShopMethodType(shopUpdates)
  }
  await updateConfigurationMethodType(newConfig)
}


export const addCity = async newCity => {
  try {
    const cityName = newCity.name.split(',')[0].replace(/\s+/g, '_');
    await updateShopOpenCitiesCityName(cityName, newCity);
  } catch (err) {
    console.error('Error adding city:', err);
  }
}

export const updateDeliveryZone = async newZone => {
  await updateShopDeliveryZoneName(newZone?.key, newZone)
}

export const removeDeliveryZone = async (zone) => {
  await deleteShopDeliveryZone(zone?.key)
};

export const createDistrict = async (newDistrict, city, isSubLocality) => {
  try {
    const data = { [newDistrict?.name?.split(',')[0]?.replace(/\s+/g, '_')]: newDistrict }
    await updateShopSubLocalitiesAndDistricts(isSubLocality, city.split(',')[0], data)
  } catch (err) {
    console.error(err) // TODO DescriptiveError
  }
};

export const addSpecialHourToFirebase = async (specialHour, key) => {
  await updateShopSpecialHour(key, specialHour)
}

export const removeSpecialHourOnFirebase = async key => {
  await deleteShopSpecialHour(key)
}

export const synchroniseMenuData = async (shops) => {
  const { nbShops } = store.getState().user
  const synchronizeAll = _.size(shops) === nbShops
  if (checkAccess('features', 'globalProduct') && shops) {
    const { shopId } = store.getState().user;
    await sendPostRequest(
      API_SYNCHRONIZE_MENU,
      { shopId, shops, synchronizeAll, replace: false },
      {}
    );
  }
};

export const updateShopData = async (legal, shop, configurations) => {
  const { address, email, name, number } = shop;
  const { businessType, businessProductType } = configurations;
  legal.businessType = BUSINESS_TYPE_CODE[businessType]
  const updates = {
    configurationCompleted: { stripe: 'launching', firebase: true },
    legal,
    address,
    name,
    support: { email, number },
    metadata: { businessProductType, businessType }
  }
  await updateShopInformation(updates)
  return true;
}